jQuery(document).ready(function () {
    jQuery('table').basictable('start');
});

